import gql from 'graphql-tag'

// Get Documents
export const gqlGetMessages = gql`
    query gqlGetMessages($page: Int!, $pageSize: Int!) {
        clientInfo {
            id
            messages(page: $page, size: $pageSize) {
                elements {
                    id
                    title
                    body
                    createdAt
                    readAt
                }
                pageInfo {
                    totalElements
                    totalPages
                    nextPageNumber
                }
            }
        }
    }
`

export const gqlMessagesCount = gql`
    query gqlMessagesCount {
        clientInfo {
            id
            messageCounts {
                unread
                total
            }
        }
    }   
`;

export const gqlMarkMessageRead = gql`
    mutation gqlMarkMessageRead(
        $messageId: ID!,
    ) {
        markMessageRead(
            messageId: $messageId,
        ){
            id
            title
            body
            createdAt
            readAt
        }
    }
`